import Vue from 'vue'
import store from '@/store'
import Router from 'vue-router'
import { auth } from '@/plugins/firebase'
// import Maintenance from './views/Maintenance.vue'
// import NotFound from './views/NotFound.vue'
// import Home from './views/Home.vue'
// import Calculator from './views/Calculator.vue'
// import ReportView from './views/ReportView.vue'
// import Privacy from './views/Privacy.vue'
// import Disclaimer from './views/Disclaimer.vue'
// import Contact from './views/Contact.vue'
// import About from './views/About.vue'
// import Assistance from './views/Assistance.vue'


const NotFound = () => import('./views/NotFound.vue')
const Home = () => import('./views/Home.vue')
const Calculator = () => import('./views/Calculator.vue')
const ReportView = () => import('./views/ReportView.vue')
const Privacy = () => import('./views/Privacy.vue')
const ServicesGuide = () => import('./views/ServicesGuide.vue')
const Contact = () => import('./views/Contact.vue')
const Consulting = () => import('./views/Consulting.vue')
const Bulletin = () => import('./views/Bulletin.vue')
// const About = () => import('./views/About.vue')
const AboutCalculator = () => import('./views/AboutCalculator.vue')
const Assistance = () => import('./views/Assistance.vue')
const Checkout = () => import('./views/Checkout.vue')
const Bookings = () => import('./views/Bookings.vue')
const Announcement = () => import('./views/Announcement.vue')


Vue.use(Router)

const redirectToCalculator = (to) => {
  let parts = to.path.split('/')
  let calculator = parts[parts.length - 1].split('.').length > 1 ? parts[parts.length - 1].split('.')[0] : parts[parts.length - 1]

  return `/calculator/${calculator}/standard`
}

const redirectRequestLink = (to, from, next) => {
  var path = `view/flv/${to.params.calculationId}`
  var query = { generateLink: true }
  next({ path: path, query: query })
//  return `view/flv/${to.params.calculationId}/?generateLink=true`
}

var requireAnonAuth = (to, from, next) => {
  var authCheck = auth.onAuthStateChanged((user) => {
    if (!user) {
      auth.signInAnonymously().catch(error => {
        console.error(error)
      })
    } else {
      store.commit('set_user', user)
      next()
      authCheck()
    }
  })
}

export default new Router({
  mode: 'history',
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    // {
    //   path: '/',
    //   component: Maintenance
    // },
    {
      path: '/',
      name: 'home',
      component: Home,
      beforeEnter: requireAnonAuth,
      meta: { }
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy,
      meta: { }
    },
    {
      path: '/services-guide',
      name: 'servicesGuide',
      component: ServicesGuide,
      meta: { }
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact,
      meta: { }
    },
    {
      path: '/bulletin',
      name: 'bulletin',
      component: Bulletin,
      meta: { }
    },
    {
      path: '/subscribe',
      name: 'bulletin',
      component: Bulletin,
      meta: { }
    },
    // {
    //   path: '/about',
    //   name: 'about',
    //   component: About,
    //   meta: { showMainFooter: true, mainAppBar: true }
    // },
    {
      path: '/assistance',
      name: 'assistance',
      component: Assistance,
      beforeEnter: requireAnonAuth,
      meta: { hideMainFooter: true }
    },
    {
      path: '/services/consulting',
      name: 'consulting',
      component: Consulting,
      // beforeEnter: requireAnonAuth,
      meta: { hideMainFooter: true }
    },
    {
      path: '/services/bookings',
      name: 'bookings',
      component: Bookings,
      // beforeEnter: requireAnonAuth,
      meta: { hideMainFooter: true, whiteToolbar: true }
    },
    {
      path: '/checkout',
      name: 'checkout',
      component: Checkout,
      beforeEnter: requireAnonAuth,
      meta: { hideMainFooter: true }
    },
    {
      path: '/announcement',
      name: 'announcement',
      component: Announcement,
      meta: { hideMainFooter: false }
    },

    {
      path: '/assistance/view/:uid/:id',
      beforeEnter: (to, from, next) => next({ path: `/assistance/view/${to.params.id}` }),
      meta: { hideMainAppBar: true, hideMainFooter: true }
    },
    {
      path: '/assistance/view/:id',
      name: 'assistance_view',
      component: Assistance,
      beforeEnter: requireAnonAuth,
      meta: { hideMainFooter: true }
    },
    {
      path: '/tools*',
      redirect: redirectToCalculator
    },
    {
      path: '/about/calculator/:calculator',
      name: 'about-calculator',
      component: AboutCalculator,
      beforeEnter: requireAnonAuth,
      meta: { }
    },
    {
      path: '/calculator/:calculator/:variant?',
      name: 'calculator',
      component: Calculator,
      beforeEnter: requireAnonAuth,
      meta: { hideMainFooter: true }
    },
    {
      path: '/view/request-link/:calculationId',
      beforeEnter: redirectRequestLink
    },
    {
      path: '/view/:calculatorId/:calculationId',
      name: 'view',
      component: ReportView,
      beforeEnter: requireAnonAuth,
      meta: { hideMainFooter: true }
    },
    {
      path: '*',
      component: NotFound,
      meta: { }
    }
  ]
})
